import React, { useState } from "react"
import moment from 'moment';
import 'moment-timezone';
import { useSelector, useDispatch } from 'react-redux';
import * as ct from 'countries-and-timezones';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";
import { Row, Col, Typography, Popover, Spin, message, Skeleton } from "antd";
import { useExcryptedNavigation } from '../../Filters/FilterConditions';
import { setReDirCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"

const { Text } = Typography;

const getTimeForCountry = (countryName, formate) => {
    const country = Object.values(ct.getAllCountries()).find(
        (c) => c.name.toLowerCase() === countryName.toLowerCase()
    );
    if (!country) return 'Unknown country';
    const timeZone = country.timezones[0];
    return moment().tz(timeZone).format((formate === "12hrs" || formate === "12-hour") ? 'hh:mm A' : 'HH:mm');
};
const UserSideDiv = ({ userData }) => {
    const dispatch = useDispatch()
    const { ExcryptedNavigation } = useExcryptedNavigation()
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const Role = localData.role
    const history = useHistory();
    const ViewDetailPage = (id, entity) => {
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    return (
        userData ? <div className='RightSide-DataShadow'>
            <div className={`user-info_image ${(Role === "Administrator" || profile.userId === userData?.userId) && "ListNavigate"}`}
                role="button"
                style={{
                    padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0,
                }}
                tabIndex={0}
                onClick={(Role === "Administrator" || profile.userId === userData?.userId) ? () => userData?.userId && ViewDetailPage(userData?.userId, "USER") : undefined}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        ViewDetailPage(userData?.userId, "USER");
                    }
                }}
            >  {userData?.profilePic !== null && userData?.profilePic
                !== undefined && userData?.profilePic !== "" ?
                <figure>
                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={userData?.profilePic} alt="" />
                </figure>
                :
                <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                    {userData?.firstName?.slice(0, 1).toUpperCase()}
                </span>}
                <figcaption style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden", // 👈 keeps ellipsis responsive
                }}>
                    <div title={`${userData?.firstName} ${userData?.lastName}`}
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    > {`${userData?.firstName} ${userData?.lastName}`}</div>
                    <div style={{
                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }} title={userData?.email}>{userData?.email}</div>
                </figcaption>
            </div> <Row gutter={30}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    {(userData?.companyRole && userData?.companyRole !== "") ?
                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Company Role</Text> <br />
                            <Text >{userData?.companyRole}</Text>
                        </div> : <></>}</Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    {(userData?.department && userData?.department !== "") ?
                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Department</Text> <br />
                            <Text >{userData?.department}</Text>
                        </div> : <></>}</Col>
            </Row>
            {(userData?.country && userData?.country !== "") ?
                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Country</Text> <br />
                    <Text ><div style={{ display: "flex", alignItems: "center", gap: 10 }}>{userData?.country}{userData?.country ? <span style={{ display: "flex", alignItems: "center", fontSize: 11, gap: 3 }}><FeatherIcon icon="clock" size={10} style={{ display: "flex", alignItems: "center" }} />{getTimeForCountry(userData?.country, profile?.timeFormat)}</span> : ""}</div></Text>
                </div> : <></>}
            {userData?.reportingManager &&
                <div><Text type="secondary" className='RightSide-Lable'>Reporting Manager</Text> <br />
                    <Text >
                        <div className={`user-info_image ${(Role === "Administrator" || profile.userId === userData?.reportingManager) && "ListNavigate"}`}
                            role="button" style={{ padding: "5px 0px 0px", display: "flex", alignItems: "center", minWidth: 0, }}
                            tabIndex={0}
                            onClick={(Role === "Administrator" || profile.userId === userData?.reportingManager) ? () => userData?.reportingManager && ViewDetailPage(userData?.reportingManager, "USER") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(userData?.reportingManager, "USER");
                                }
                            }}> {userData?.reportingMangerProfilePic !== null && userData?.reportingMangerProfilePic
                                !== undefined && userData?.reportingMangerProfilePic !== "" ?
                                <figure>
                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={userData?.reportingMangerProfilePic} alt="" />
                                </figure>
                                :
                                <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                    {userData?.reportingMangerFirstName?.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div title={`${userData?.reportingMangerFirstName} ${userData?.reportingMangerLastName}`}
                                    style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                > {`${userData?.reportingMangerFirstName} ${userData?.reportingMangerLastName}`}</div>
                                <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={userData?.reportingMangerEmail}>{userData?.reportingMangerEmail}</div>
                            </figcaption>
                        </div>
                    </Text>
                </div>
            }
        </div > : <div className='RightSide-DataShadow'>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "10rem"
            }}>
                <Spin />
            </div>
        </div>
    )
}
UserSideDiv.propTypes = {
    userData: PropTypes.object.isRequired,
};
const UserCenterCard = ({ item, index, widths }) => {
    const dispatch = useDispatch()
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const history = useHistory();
    const ViewDetailPage = (id, entity) => {
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    return (<div className='RightSide-DataShadow' key={index} style={{ marginBottom: 15, width: widths ? "240px" : "auto" }}>
        <div className={`user-info_image ${(Role === "Administrator" || profile.userId === item?.userId) && "ListNavigate"}`}
            role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
            tabIndex={0}
            onClick={(Role === "Administrator" || profile.userId === item?.userId) ? () => item?.userId && ViewDetailPage(item?.userId, "USER") : undefined}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    ViewDetailPage(item?.userId, "USER");
                }
            }}
        >  {item?.profilePic !== null && item?.profilePic
            !== undefined && item?.profilePic !== "" ?
            <figure>
                <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.profilePic} alt="" />
            </figure>
            :
            <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                {item?.firstName?.slice(0, 1).toUpperCase()}
            </span>
            }
            <figcaption style={{
                display: "flex",
                flexDirection: "column",
                overflow: "hidden", // 👈 keeps ellipsis responsive
            }}>
                <div title={`${item?.firstName} ${item?.lastName}`}
                    style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >  {`${item?.firstName} ${item?.lastName}`}</div>
                <div style={{
                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }} title={item?.email}>{item?.email}</div>
            </figcaption>
        </div>
        <Row gutter={30}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.companyRole && item?.companyRole !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Company Role</Text> <br />
                        <Text >{item?.companyRole}</Text>
                    </div> : <></>}</Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.department && item?.department !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Department</Text> <br />
                        <Text >{item?.department}</Text>
                    </div> : <></>}</Col>
        </Row>
        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Country</Text> <br />
            <Text >{(item?.country && item?.country !== "") ?
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>{item?.country}{item?.country ? <span style={{ display: "flex", alignItems: "center", fontSize: 11, gap: 3 }}><FeatherIcon icon="clock" size={10} style={{ display: "flex", alignItems: "center" }} />{getTimeForCountry(item?.country, profile?.timeFormat)}</span> : ""}</div>
                : <>Not Available</>}</Text>
        </div>
        <div><Text type="secondary" className='RightSide-Lable'>Reporting Manager</Text> <br />
            <Text >
                <div className={`user-info_image ${(Role === "Administrator" || profile.userId === item?.reportingManager) && "ListNavigate"}`}
                    role="button" style={{ padding: "5px 0px 0px", display: "flex", alignItems: "center", minWidth: 0, }}
                    tabIndex={0}
                    onClick={(Role === "Administrator" || profile.userId === item?.reportingManager) ? () => item?.reportingManager && ViewDetailPage(item?.reportingManager, "USER") : undefined}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            ViewDetailPage(item?.reportingManager, "USER");
                        }
                    }}>
                    {item?.reportingManager ? <>
                        {item?.reportingMangerProfilePic !== null && item?.reportingMangerProfilePic
                            !== undefined && item?.reportingMangerProfilePic !== "" ?
                            <figure>
                                <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.reportingMangerProfilePic} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                {item?.reportingMangerFirstName?.slice(0, 1).toUpperCase()}
                            </span>}
                        <figcaption style={{
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden", // 👈 keeps ellipsis responsive
                        }}>
                            <div title={`${item?.reportingMangerFirstName} ${item?.reportingMangerLastName}`}
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >  {`${item?.reportingMangerFirstName} ${item?.reportingMangerLastName}`}</div>
                            <div style={{
                                fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }} title={item?.reportingMangerEmail}>{item?.reportingMangerEmail}</div>
                        </figcaption></> : <>
                        <Skeleton.Avatar size={40} shape="circle" />
                        <figcaption style={{ marginLeft: 10 }}>
                            <div>Not Applicable</div>
                        </figcaption></>}
                </div>
            </Text>
        </div>
    </div>)
}
UserCenterCard.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    widths: PropTypes.number
};
const UploadUserTag = ({ record, page }) => {
    const dispatch = useDispatch()
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const history = useHistory();
    const ViewDetailPage = (id, entity) => {
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }

    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const isNavigable = Role === "Administrator" || profile.userId === record.uploadedById;

    const fetchUserInfo = async () => {
        if (!record.uploadedById || loading || userData) return;
        setLoading(true);
        try {
            const Response = await FetchUserDetails(record.uploadedById)
            setUserData(Response?.data);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };

    const popoverContent = loading
        ? <Spin size="small" />
        : userData
            ? <UserCenterCard item={userData} index={0} widths={240} />
            : <span>No data found</span>;

    return (
        <>
            {record.uploadedById ?
                <div
                    className='Div_flex'
                    style={{
                        margin: "0px",
                        justifyContent: page === "ReDoc" && "flex-end",
                        minWidth: 0,
                        overflow: "hidden"
                    }}
                >
                    <Popover
                        content={!isNavigable ? popoverContent : null}
                        placement="topRight"
                        trigger="hover"
                        onOpenChange={(visible) => {
                            if (visible && !isNavigable) {
                                fetchUserInfo();
                            }
                        }}
                        overlayClassName="user-popover"
                    >
                        <div
                            title={record.uploadedBy}
                            className={`${(page === "ReDoc" || page === "ReDocs") ? "doc-Navigation" : "share_image"} ${(Role === "Administrator" || profile.userId === record.uploadedById) && "ListNavigate"}`}
                            role="button"
                            tabIndex={0}
                            onClick={(Role === "Administrator" || profile.userId === record.uploadedById) ? () => record.uploadedById && ViewDetailPage(record.uploadedById, "USER") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(record.uploadedById, "USER");
                                }
                            }}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                minWidth: 0,
                                overflow: "hidden"
                            }}
                        >
                            {record?.uploadedProfile !== null && record?.uploadedProfile !== undefined && record?.uploadedProfile !== "" ?
                                <img
                                    style={{ width: "30px", height: "30px", flexShrink: 0 }}
                                    src={record?.uploadedProfile}
                                    alt=""
                                />
                                :
                                <span className="image_icon UserIcon" style={{ flexShrink: 0 }}>
                                    {record?.uploadedBy?.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <span style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                minWidth: 0
                            }}>
                                {record.uploadedBy}
                            </span>
                        </div>
                    </Popover>
                </div> : ""}
        </>
    )
}
UploadUserTag.propTypes = {
    record: PropTypes.object.isRequired,
    page: PropTypes.string.isRequired,
};
const DetailsOtherInfoUser = ({ record, pageRef }) => {
    const dispatch = useDispatch()
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const history = useHistory();
    const ViewDetailPage = (id, entity) => {
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }

    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const isNavigable = Role === "Administrator" || profile.userId === record.recordby;

    const fetchUserInfo = async () => {
        if (!record.recordby || loading || userData) return;
        setLoading(true);
        try {
            const Response = await FetchUserDetails(record.recordby)
            setUserData(Response?.data);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };
    const popoverContent = loading
        ? <Spin size="small" />
        : userData
            ? <UserCenterCard item={userData} index={0} widths={240} />
            : <span>No data found</span>;
    return (
        <>
            <Popover
                content={!isNavigable ? popoverContent : null}
                placement="topLeft"
                // content={popoverContent}
                trigger="hover"
                // title={!isNavigable ? "User Info" : null}
                onOpenChange={(visible) => {
                    if (visible && !isNavigable) {
                        // if (visible) {
                        fetchUserInfo();
                    }
                }}
                overlayClassName="user-popover"
            >
                <div style={{ display: "flex" }}>
                    <span className={`user-info_image ${(Role === "Administrator" || profile.userId === record.recordby) ? "ListNavigate" : "ListNavigate3"}`}
                        role="button"
                        tabIndex={0}
                        onClick={(Role === "Administrator" || profile.userId === record.recordby) ? () => record.recordby && ViewDetailPage(record.recordby, "USER") : undefined}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                ViewDetailPage(record.recordby, "USER");
                            }
                        }}
                    >
                        {record?.recordby &&
                            <figcaption>
                                <div>
                                    {`${record?.recordbyFName} ${record?.recordbyLName}`}
                                </div>
                            </figcaption>
                        }</span>
                    {pageRef !== "ReTask" ? <>
                        <span style={{ margin: "0px 5px" }}> on </span>
                        <span>
                            {record?.date}
                        </span></> : ""}
                </div>
            </Popover>
        </>
    )
}
DetailsOtherInfoUser.propTypes = {
    record: PropTypes.object.isRequired,
    pageRef: PropTypes.string.isRequired,
};
const UserCenterCard1 = ({ item }) => {
    const dispatch = useDispatch()
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const history = useHistory();
    const ViewDetailPage = (id, entity) => {
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    return (
        <>
            <div className={`user-info_image ${(Role === "Administrator" || profile.userId === item?.userId) && "ListNavigate"}`}
                role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                tabIndex={0}
                onClick={(Role === "Administrator" || profile.userId === item?.userId) ? () => item?.userId && ViewDetailPage(item?.userId, "USER") : undefined}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        ViewDetailPage(item?.userId, "USER");
                    }
                }}
            >  {item?.profilePic !== null && item?.profilePic
                !== undefined && item?.profilePic !== "" ?
                <figure>
                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.profilePic} alt="" />
                </figure>
                :
                <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                    {item?.firstName?.slice(0, 1).toUpperCase()}
                </span>
                }
                <figcaption style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden", // 👈 keeps ellipsis responsive
                }}>
                    <div title={`${item?.firstName} ${item?.lastName}`}
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    > {`${item?.firstName} ${item?.lastName}`}</div>
                    <div style={{
                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }} title={item?.email}>{item?.email}</div>
                </figcaption>
            </div>
            <Row gutter={30}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    {(item?.companyRole && item?.companyRole !== "") ?
                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Company Role</Text> <br />
                            <Text >{item?.companyRole}</Text>
                        </div> : <></>}</Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    {(item?.department && item?.department !== "") ?
                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Department</Text> <br />
                            <Text >{item?.department}</Text>
                        </div> : <></>}</Col>
            </Row>
            {(item?.country && item?.country !== "") ?
                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Country</Text> <br />
                    <Text ><div style={{ display: "flex", alignItems: "center", gap: 10 }}>{item?.country}{item?.country ? <span style={{ display: "flex", alignItems: "center", fontSize: 11, gap: 3 }}><FeatherIcon icon="clock" size={10} style={{ display: "flex", alignItems: "center" }} />{getTimeForCountry(item?.country, profile?.timeFormat)}</span> : ""}</div></Text>
                </div> : <></>}
            {item?.reportingManager &&
                <div><Text type="secondary" className='RightSide-Lable'>Reporting Manager</Text> <br />
                    <Text >
                        <div className={`user-info_image ${(Role === "Administrator" || profile.userId === item?.reportingManager) && "ListNavigate"}`}
                            role="button" style={{ padding: "5px 0px 0px", display: "flex", alignItems: "center", minWidth: 0, }}
                            tabIndex={0}
                            onClick={(Role === "Administrator" || profile.userId === item?.reportingManager) ? () => item?.reportingManager && ViewDetailPage(item?.reportingManager, "USER") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(item?.reportingManager, "USER");
                                }
                            }}> {item?.reportingMangerProfilePic !== null && item?.reportingMangerProfilePic
                                !== undefined && item?.reportingMangerProfilePic !== "" ?
                                <figure>
                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.reportingMangerProfilePic} alt="" />
                                </figure>
                                :
                                <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                    {item?.reportingMangerFirstName?.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div title={`${item?.reportingMangerFirstName} ${item?.reportingMangerLastName}`}
                                    style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                > {`${item?.reportingMangerFirstName} ${item?.reportingMangerLastName}`}</div>
                                <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={item?.reportingMangerEmail}>{item?.reportingMangerEmail}</div>
                            </figcaption>
                        </div>
                    </Text>
                </div>
            }
        </>)
}
UserCenterCard1.propTypes = {
    item: PropTypes.object.isRequired,
};
const UserOwnerDetails = ({ record }) => {
    const dispatch = useDispatch()
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const history = useHistory();
    const ViewDetailPage = (id, entity) => {
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }

    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const isNavigable = Role === "Administrator" || profile.userId === record.recordby;

    const fetchUserInfo = async () => {
        if (!record.recordby || loading || userData) return;
        setLoading(true);
        try {
            const Response = await FetchUserDetails(record.recordby)
            setUserData(Response?.data);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };
    const popoverContent = loading
        ? <Spin size="small" />
        : userData
            ? <UserCenterCard item={userData} index={0} widths={240} />
            : <span>No data found</span>;
    return (
        <>
            <Popover
                content={!isNavigable ? popoverContent : null}
                placement="topLeft"
                // content={popoverContent}
                trigger="hover"
                // title={!isNavigable ? "User Info" : null}
                onOpenChange={(visible) => {
                    if (visible && !isNavigable) {
                        // if (visible) {
                        fetchUserInfo();
                    }
                }}
                overlayClassName="user-popover"
            >
                <div className={`user-info_image ${(Role === "Administrator" || profile.userId === record.recordby) ? "ListNavigate" : "ListNavigate3"}`}
                    role="button"
                    tabIndex={0}
                    onClick={(Role === "Administrator" || profile.userId === record.recordby) ? () => record.recordby && ViewDetailPage(record.recordby, "USER") : undefined}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            ViewDetailPage(record.recordby, "USER");
                        }
                    }}
                >
                    {record?.recordby && (record?.recordbyProfilePic !== null && record?.recordbyProfilePic
                        !== undefined && record?.recordbyProfilePic !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={record?.recordbyProfilePic} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag UserIcon'>
                            {record?.recordbyFName?.slice(0, 1).toUpperCase()}
                        </span>
                    )
                    }
                    {record?.recordby &&
                        <figcaption>
                            <div>
                                {`${record?.recordbyFName} ${record?.recordbyLName ? record?.recordbyLName : ""}`}
                            </div>
                        </figcaption>
                    }
                </div>
            </Popover>
        </>
    )
}
UserOwnerDetails.propTypes = {
    record: PropTypes.object.isRequired,
};
export { UploadUserTag, UserSideDiv, UserCenterCard, DetailsOtherInfoUser, UserCenterCard1, UserOwnerDetails }